var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { useEffect, useMemo, useState } from 'react';
import useTravelerLabel from '../useTravelerLabel';
import useTravelerError from '../useTravelerError';
import { DEFAULT_MAX_TRAVELERS } from '../constants';
var defaultInitialValues = {
  rooms: 1,
  adults: 1,
  children: 0,
  childrenAges: {},
  lapInfants: 0
};
function useTravelerSelection(_a) {
  var ageSelectEnabled = _a.ageSelectEnabled,
    externalErrorMessage = _a.errorMessage,
    initialValues = _a.initialValues,
    isInternationalFlight = _a.isInternationalFlight,
    isWhiteLabel = _a.isWhiteLabel,
    maxTravelers = _a.maxTravelers,
    _b = _a.shouldCountLapInfant,
    shouldCountLapInfant = _b === void 0 ? false : _b;
  var startValues = useMemo(function () {
    return __assign(__assign({}, defaultInitialValues), initialValues);
  }, [initialValues]);
  var _c = useState(startValues.rooms),
    rooms = _c[0],
    setRooms = _c[1];
  var _d = useState(startValues.adults),
    adults = _d[0],
    setAdults = _d[1];
  var _e = useState(startValues.children),
    children = _e[0],
    setChildren = _e[1];
  var _f = useState(startValues.childrenAges),
    childrenAges = _f[0],
    setChildrenAges = _f[1];
  var _g = useState(startValues.lapInfants),
    lapInfants = _g[0],
    setLapInfants = _g[1];
  var _h = useState(null),
    errorMessage = _h[0],
    setErrorMessage = _h[1];
  var label = useTravelerLabel({
    adults: adults,
    children: children,
    lapInfants: lapInfants,
    rooms: rooms
  });
  var calculatedErrorMessage = externalErrorMessage ? externalErrorMessage : useTravelerError({
    children: children,
    childrenAges: childrenAges,
    lapInfants: lapInfants,
    ageSelectEnabled: ageSelectEnabled,
    isInternationalFlight: isInternationalFlight,
    isWhiteLabel: isWhiteLabel
  });
  if (calculatedErrorMessage !== errorMessage) {
    setErrorMessage(calculatedErrorMessage);
  }
  useEffect(function () {
    setRooms(startValues.rooms);
    setAdults(startValues.adults);
    setChildren(startValues.children);
    setChildrenAges(startValues.childrenAges);
    setLapInfants(startValues.lapInfants);
  }, [startValues]);
  var passengerCount = adults + children + (shouldCountLapInfant ? lapInfants : 0);
  var remainingTravelerCount = Math.max((maxTravelers || DEFAULT_MAX_TRAVELERS) - passengerCount, 0);
  var removeChildrenAge = function (index) {
    var copy = childrenAges;
    delete copy[index];
    setChildrenAges(copy);
  };
  var onAdultsChange = function (count) {
    setAdults(count);
    if (count < lapInfants) {
      setLapInfants(count);
    }
  };
  var onChildrenChange = function (count) {
    setChildren(count);
    removeChildrenAge(count);
  };
  var onAgesChange = function (index, value) {
    var _a;
    setChildrenAges(__assign(__assign({}, childrenAges), (_a = {}, _a[index] = value, _a)));
  };
  return {
    label: label,
    errorMessage: errorMessage,
    rooms: rooms,
    adults: adults,
    children: children,
    childrenAges: childrenAges,
    lapInfants: lapInfants,
    remainingTravelerCount: remainingTravelerCount,
    setRooms: setRooms,
    setAdults: onAdultsChange,
    setChildren: onChildrenChange,
    setChildrenAges: onAgesChange,
    setLapInfants: setLapInfants
  };
}
export default useTravelerSelection;